import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=237ae3bf"
import script from "./FormTextArea.vue?vue&type=script&lang=ts"
export * from "./FormTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports